import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock, Zap, Globe, Check } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
const BASE_URL = 'https://kit-online-2026.myshopify.com/cart/44581699879047:1';
const PREMIUM_URL = 'https://kit-online-2026.myshopify.com/cart/44581703417991:1';
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-4 py-8 px-4 bg-brand-cream" data-id="element-160">
      <div className="max-w-6xl mx-auto" data-id="element-161">
        <div className="text-center mb-6" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-navy uppercase leading-tight" data-id="element-163">
            Elegí el plan que{' '}
            <span className="yellow-highlight" data-id="element-164">mejor se adapta a vos:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-165">
          {/* BASE */}
          <div className="brunson-card rounded-xl p-5 md:p-7 flex flex-col relative" data-id="element-166">
            <div className="text-center mb-3" data-id="element-167">
              <p className="text-brand-cta font-display font-bold uppercase text-xs tracking-widest" data-id="element-168">
                ✅ Opción Base
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-brand-navy uppercase leading-tight mt-1" data-id="element-169">
                Sistema Completo
                <br data-id="element-170" />
                Acuicultura Pro™
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-171">
                Todo lo que necesitás para transformar tus clases desde el
                primer día
              </p>
            </div>

            <ul className="space-y-2 mb-4 flex-grow" data-id="element-172">
              {['6 Tomos Maestros (500+ páginas)', 'Bono 1 — 50 Actividades', 'Bono 2 — Evaluaciones y Rúbricas', 'Bono 3 — Proyectos Prácticos', 'Bono 4 — Planificación Anual Editable', 'Actualizaciones de por vida'].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-173">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-cta shrink-0 mt-0.5" strokeWidth={3} data-id="element-174" />
                  <span className="text-sm md:text-base text-brand-ink font-medium" data-id="element-175">
                    {f}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-creamAlt rounded-lg p-3 text-center mb-4 border border-brand-line" data-id="element-176">
              <p className="text-xs text-brand-mute font-bold uppercase" data-id="element-177">
                Valor total: <span className="line-through" data-id="element-178">USD 265</span>
              </p>
              <p className="font-display text-4xl md:text-5xl font-bold text-brand-red leading-none mt-1" data-id="element-179">
                🔥 USD 19,90
              </p>
              <p className="text-[11px] text-brand-mute font-medium mt-1" data-id="element-180">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <Button href={BASE_URL} variant="green" data-id="element-181">
              🚀 Quiero el Sistema Base
            </Button>
            <Trust data-id="element-182" />
          </div>

          {/* PREMIUM */}
          <div className="bg-white rounded-xl p-5 md:p-7 flex flex-col relative border-4 border-brand-yellowDark shadow-[0_8px_0_#0F2A4A,0_12px_32px_rgba(15,42,74,0.25)]" data-id="element-183">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-red text-white font-display font-bold text-xs md:text-sm tracking-widest px-4 py-1.5 rounded-full uppercase border-2 border-brand-navy whitespace-nowrap" data-id="element-184">
              🏅 Más Recomendado
            </div>

            <div className="text-center mb-3 mt-2" data-id="element-185">
              <p className="text-brand-yellowDark font-display font-bold uppercase text-xs tracking-widest" data-id="element-186">
                ⭐ Opción Premium
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-brand-navy uppercase leading-tight mt-1" data-id="element-187">
                Sistema Completo
                <br data-id="element-188" />+ Mega Banco Acuícola Pro
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-189">
                Para el docente que quiere ir más lejos que el resto
              </p>
            </div>

            <div className="bg-brand-yellow/30 border border-brand-yellowDark rounded-lg p-3 mb-3" data-id="element-190">
              <p className="text-xs font-display font-bold text-brand-navy uppercase tracking-wide mb-1" data-id="element-191">
                💎 Mega Banco Acuícola Pro — El Arsenal Técnico de Élite
              </p>
              <p className="text-xs text-brand-ink leading-snug font-medium" data-id="element-192">
                El arsenal técnico más avanzado con actividades de alto nivel,
                simulaciones dinámicas y casos de crisis reales diseñados para
                transformar grupos técnicos en expertos de élite del sector
                acuícola. Todo lo necesario para pasar de la enseñanza
                tradicional a la consultoría profesional en un solo sistema.
              </p>
            </div>

            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-193">
              {['Todo lo del plan base', '💎 Mega Banco Acuícola Pro', 'Actividades de alto nivel', 'Simulaciones dinámicas', 'Casos de crisis reales'].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-194">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-cta shrink-0 mt-0.5" strokeWidth={3} data-id="element-195" />
                  <span className="text-sm md:text-base text-brand-ink font-medium" data-id="element-196">
                    {f}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-yellow/40 rounded-lg p-3 text-center mb-4 border-2 border-brand-yellowDark" data-id="element-197">
              <p className="text-xs text-brand-mute font-bold uppercase" data-id="element-198">
                Valor total: <span className="line-through" data-id="element-199">USD 562</span>
              </p>
              <p className="font-display text-4xl md:text-5xl font-bold text-brand-red leading-none mt-1" data-id="element-200">
                🔥 USD 23,90
              </p>
              <p className="text-[11px] text-brand-navy font-bold mt-1" data-id="element-201">
                Solo USD 4 más que la opción base
              </p>
            </div>

            <Button href={PREMIUM_URL} variant="gold" data-id="element-202">
              🚀 Quiero el Mega Banco Pro
            </Button>
            <Trust data-id="element-203" />
          </div>
        </div>

        <p className="text-center text-[11px] md:text-xs text-brand-mute font-medium mt-5 max-w-3xl mx-auto leading-snug" data-id="element-204">
          El precio está expresado en dólares estadounidenses (USD). El cobro se
          realiza automáticamente en la moneda de tu país al tipo de cambio del
          momento de la compra.
        </p>
      </div>
    </section>;
}
function Trust() {
  return <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-3 text-[10px] md:text-xs font-bold text-brand-navy uppercase tracking-wide" data-id="element-205">
      <div className="flex items-center" data-id="element-206">
        <Lock className="w-3 h-3 mr-1 text-brand-cta" data-id="element-207" /> Pago seguro
      </div>
      <div className="flex items-center" data-id="element-208">
        <Zap className="w-3 h-3 mr-1 text-brand-cta" data-id="element-209" /> Acceso 5 min
      </div>
      <div className="flex items-center" data-id="element-210">
        <Globe className="w-3 h-3 mr-1 text-brand-cta" data-id="element-211" /> En tu moneda
      </div>
      <div className="flex items-center" data-id="element-212">
        <ShieldCheck className="w-3 h-3 mr-1 text-brand-cta" data-id="element-213" /> Garantía 7 días
      </div>
    </div>;
}